module.exports = __webpack_public_path__ + "static/media/restart.e6b2e551.svg";